
export enum WalletType {
	Fiat = 1,
	Crypto = 2
}